import React from 'react';

const SvgNaviconHome = (props) => {
  return (
    <svg
      data-name="Layer 1"
      viewBox="0 0 300 300"
      {...props}
    >
      <path
        d="M263 124.58L152.07 18.85a3 3 0 00-4.14 0L37 124.58a2.76 2.76 0 00-.87 2v152.49a3 3 0 003.2 2.86h75.07a3 3 0 003-3v-91.86a3 3 0 013-3h59.22a3 3 0 013 3v91.86a3 3 0 003 3h75.07a3 3 0 003.2-2.86V126.55a2.76 2.76 0 00-.89-1.97z"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={10.079}
      />
    </svg>
  );
};

export default SvgNaviconHome;
